import { Helmet } from "react-helmet-async";

interface SeoTagsProps {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: string;
}

const SITE = "https://snippsnapp.se";
const DEFAULT_IMAGE =
  "https://storage.googleapis.com/gpt-engineer-file-uploads/glRPJxr7QCO1VRFyarEbo1BjLrE3/social-images/social-1768559683783-SnippSnapp share image.png";

export default function SeoTags({
  title,
  description,
  path,
  image = DEFAULT_IMAGE,
  type = "website",
}: SeoTagsProps) {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
